import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(routes)/(auth)/components/auth-carousel-panel.tsx");
